const emailTemplateModalLocale = require('./collaboration/email/emailTemplateModal/emailTemplateModal.i18n.json');

/*@ngInject*/
const SubmissionController = function ($q, $scope, $rootScope, $state, $stateParams, $location, coreMediator, submissionConstant, submissionMediator, submissionStatus, accountMediator, submissionStateMediator, loadingBarHandler, alertHandler, preferenceModel, currentSubmissionModel, coreConstant, formViewerConstant, localization, modalUtil) {

    let translations;

    localization.getTranslations().then(function (result) {
        translations = result;
    });

    $scope.emailTemplateModalI18n = emailTemplateModalLocale;

    $scope.submissionViewModel = {
        showLongRequestWarning: true,
        hasSubmissionLoaded: false,
        isDrawerOpen: submissionStateMediator.getSubmissionDrawerState($stateParams.submissionId),
        environment: '',
        printPreview: $stateParams.print,
        isPrintingCollab: $state.current.name === 'submission.printCollaboration',
        isViewContentInitialized: false
    };

    $scope.upgradeProcessComplete = false;

    $scope.$on(submissionConstant.event.REDIRECT_TO_OVERVIEW, function (event, refreshFormId) {
        let params = {
            submissionId: $stateParams.submissionId
        };
        if (refreshFormId) {
            _.assignIn(params, {
                formId: null
            });
        }

        $state.go('submission.default', params, { reload: true });
    });

    $scope.$on(submissionConstant.event.RELOAD_SUBMISSION, function (event, submissionId) {
        if ($stateParams.submissionId === submissionId) {
            $state.go($state.current.name, $state.params, {reload: true});
        }
    });

    $scope.$on(submissionConstant.event.SHOW_LOADING_BAR, function (event, message, submissionId) {
        if ($stateParams.submissionId === submissionId) {
            loadingBarHandler.showLoadingBar(message);
        }
    });

    $scope.$on(submissionConstant.event.HIDE_LOADING_BAR, function (event, submissionId) {
        if ($stateParams.submissionId === submissionId) {
            loadingBarHandler.hideLoadingBar();
        }
    });

    $scope.$on(formViewerConstant.event.FORM_LAZY_RENDERING_START, function () {
        $scope.submissionViewModel.showFormRenderingSpinner = true;
    });

    $scope.$on(formViewerConstant.event.FORM_LAZY_RENDERING_END, function () {
        $scope.submissionViewModel.showFormRenderingSpinner = false;
    });

    $scope.isFormViewerPresent = function () {
        return $state.current.name === 'submission.form';
    };

    $scope.closeDrawer = function () {
        $scope.submissionViewModel.isDrawerOpen = false;
        submissionStateMediator.saveSubmissionDrawerState($stateParams.submissionId, $scope.submissionViewModel.isDrawerOpen);
    };

    $scope.onToggleDrawer = function () {
        $scope.submissionViewModel.isDrawerOpen = !$scope.submissionViewModel.isDrawerOpen;
        submissionStateMediator.saveSubmissionDrawerState($stateParams.submissionId, $scope.submissionViewModel.isDrawerOpen);
    };

    $scope.$on(coreConstant.event.SHOW_LONG_REQUEST_WARNING, function () {
        $scope.submissionViewModel.showLongRequestWarning = true;
    });

    $scope.$on(coreConstant.event.HIDE_LONG_REQUEST_WARNING, function () {
        $scope.submissionViewModel.showLongRequestWarning = false;
    });

    function handleStateChangeStart(toState, toParams) {
        let printPreview = toParams.print;

        const isSubmissionState = !_.isEmpty(toParams.submissionId),
            isSubmissionForm = (toState.name === 'submission.form'),
            isSubmissionDocument = ((toState.name === 'submission.document') && toParams.attachmentId > 0),
            isSubmissionFormSummaryGrid = ((toState.name === 'submission.formSummaryGridDetail') && _.parseInt(toParams.formSummaryInstanceId) > 0 && _.parseInt(toParams.ownerUriId) > 0);

        if (isSubmissionState) {
            // Make sure we have a valid submissionId, and only save Submission state for overview, forms and document viewers.
            if ((isSubmissionForm || isSubmissionDocument || isSubmissionFormSummaryGrid)) {
                submissionStateMediator.saveSubmissionStateUrl(toParams.submissionId, toState.name, toParams);
            }

            if (!isSubmissionForm) {
                $scope.submissionViewModel.isViewContentInitialized = true;
            }

            if (toState.name === 'submission.print') {
                printPreview = true;
            }
            $scope.submissionViewModel.printPreview = printPreview;
        } else {
            submissionMediator.clearCurrentSubmissionRegistrations();
        }
    }

    function loadSubmission() {

        function upgradeSubmissionAndAccountForms(submission) {
            const defer = $q.defer();

            submissionMediator.formNeedsUpgrade($stateParams.submissionId).then(function (submissionFormNeedsUpgrade) {
                accountMediator.formNeedsUpgrade(submission.accountId).then(function (accountFormNeedsUpgrade) {
                    let promiseList = [],
                        upgradedFormsCount = 0;

                    if (submissionFormNeedsUpgrade || accountFormNeedsUpgrade) {
                        loadingBarHandler.showLoadingBar('submission.upgradingForms');

                        if (submissionFormNeedsUpgrade) {
                            promiseList.push(submissionMediator.upgradeForms($stateParams.submissionId).then(function (numberOfFormsUpgraded) {
                                if (numberOfFormsUpgraded > 0) {
                                    upgradedFormsCount += numberOfFormsUpgraded;
                                }
                            }));
                        }

                        if (accountFormNeedsUpgrade) {
                            promiseList.push(accountMediator.upgradeForms(submission.accountId).then(function (numberOfFormsUpgraded) {
                                if (numberOfFormsUpgraded > 0) {
                                    upgradedFormsCount += numberOfFormsUpgraded;
                                }
                            }));
                        }

                        $q.all(promiseList).then(function () {
                            if (upgradedFormsCount > 0) {
                                const upgradeNotificationContext = {
                                    formsCount: upgradedFormsCount,
                                    formsText: upgradedFormsCount === 1 ? _.get(translations, 'formsViewer.formUpgrade.singularMessage') : _.get(translations, 'formsViewer.formUpgrade.pluralMessage')
                                };
                                coreMediator.getNotificationPopupTemplate('notification.upgradeForms', upgradeNotificationContext).then(function (notificationPreference) {
                                    loadingBarHandler.hideLoadingBar();
                                    $scope.upgradeProcessComplete = true;

                                    alertHandler.showAlert(notificationPreference);

                                    defer.resolve();
                                });
                            } else {
                                loadingBarHandler.hideLoadingBar();
                                $scope.upgradeProcessComplete = true;
                                defer.resolve();
                            }
                        });
                    } else {
                        $scope.upgradeProcessComplete = true;
                        defer.resolve();
                    }
                });
            });

            return defer.promise;
        }

        function synchronizeAccount(submission) {
            if (!_.isNil(submission.accountNumber) && submission.status >= submissionStatus.SUBMITTED) {
                accountMediator.synchronizeAccount(submission.accountId);
            }
        }

        submissionMediator.clearCurrentSubmissionRegistrations().finally(function () {
            submissionMediator.loadSubmission($stateParams.submissionId).then(function (submission) {
                upgradeSubmissionAndAccountForms(submission).then(function () {
                    synchronizeAccount(submission);

                    submissionMediator.setCurrentSubmission(submission);
                    submissionMediator.setSubmissionOpenHistory(submission.id);
                    $scope.submissionViewModel.hasSubmissionLoaded = true;
                });
            });
        });
    }

    $scope.$on(submissionConstant.event.TOGGLE_NAVIGATION_MENU, $scope.onToggleDrawer);

    $scope.$on('$stateChangeStart', function (event, toState, toParams) {
        handleStateChangeStart(toState, toParams);

        $scope.submissionViewModel.isPrintingCollab = toState.name === 'submission.printCollaboration';

        if (!$scope.isLargeScreen) {
            $scope.closeDrawer();
        }
        if (currentSubmissionModel.doCreateDraftEmail) {
            $rootScope.$broadcast(coreConstant.event.HANDLE_EMAIL_FROM_BUSINESS_CARD, $stateParams.submissionId, parseInt(currentSubmissionModel.sendMailUserId));
            /*
             * UMS-26310
             * Use the chatMessageId, emailMessageId, or notificationId property
             * as a query parameter in the "POST /Email/SendNotification" request.
             * This is step 2b of 6.
             * The next step is in the EmailResource.sendEmailNotification method.
             * The previous step is in the function handling SHOW_USER_BUSINESS_CARD below.
             */
            let options = undefined;
            if ($scope.chatMessageId) {
                options = { variables: { chatMessageId: $scope.chatMessageId } };
            } else if ($scope.emailMessageId) {
                options = { variables: { emailMessageId: $scope.emailMessageId } };
            } else if ($scope.notificationId) {
                options = { variables: { notificationId: $scope.notificationId } };
            }
            coreMediator.sendEmailNotification('notification.sendEmailFromEmailCollaborationTool', /*isCustom=*/true, $stateParams.submissionId, options);
            currentSubmissionModel.doCreateDraftEmail = false;
            currentSubmissionModel.sendMailUserId = null;
        }
    });

    $scope.$on(formViewerConstant.INITIAL_RENDERING_COMPLETE, function () {
        $scope.submissionViewModel.isViewContentInitialized = true;
    });

    $scope.$on(coreConstant.event.SHOW_CUSTOM_ALERT_MODAL_NOTIFICATION, function (event, options) {
        let currentSubmission = currentSubmissionModel.getCurrentSubmission();
        modalUtil.showCustomAlertModal(options, currentSubmission);
    });

    $scope.$on('$destroy', function () {
        submissionMediator.resetCurrentSubmission();
    });

    $scope.$on(coreConstant.event.LOGOUT_COMPLETE, function () {
        currentSubmissionModel.clearRegistrations();
    });

    handleStateChangeStart($state.current.name, $stateParams);
    loadSubmission();

    if (!$scope.isFormViewerPresent()) {
        $scope.submissionViewModel.isViewContentInitialized = true;
    }
};

angular.module('gw-um-submission')
    .controller('submissionController', SubmissionController);
